import { type ApolloError } from '@apollo/client/errors';
import { type SupplierListItem } from '@choco-admin/types';

import { useGetSupplierDetailsDataQuery } from '../../../generated';
import { mapSupplierToProfileItem } from '../mappers/supplierMapper';

interface UseSupplierDetailsParams {
  id: string;
}

interface UseSupplierDetailsResult {
  supplier: SupplierListItem | null;
  isLoading: boolean;
  error: ApolloError | undefined;
  refetch: () => Promise<any>;
}

export const useSupplierDetails = ({
  id,
}: UseSupplierDetailsParams): UseSupplierDetailsResult => {
  const {
    data,
    loading: isLoading,
    error,
    refetch,
  } = useGetSupplierDetailsDataQuery({
    variables: { id },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const mappedSupplier = data?.supplier
    ? mapSupplierToProfileItem(data.supplier)
    : null;

  return {
    supplier: mappedSupplier,
    isLoading,
    error: error as ApolloError | undefined,
    refetch,
  };
};
